import {HttpClient, HttpHeaders} from '@angular/common/http';
import {EventEmitter, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {environment} from '../../../../environments/environment';
import {CaptchaModel} from '../../shared/models/captcha.model';
import {AUTHENTICATE, TOKEN_PADRAO} from './../../../app.constants';


@Injectable()
export class LoginService {

    mostrarMenuEmitter = new EventEmitter<boolean>();
    mostrarLoginInputEmitter = new EventEmitter<boolean>();
    captchaKey: Object;

    constructor(private router: Router, protected http: HttpClient) {
    }


    fazerLogin(usuario, token) {
        return this.http.post(`${AUTHENTICATE}`, usuario, {
            headers: new HttpHeaders().set('Authorization', token),
            observe: 'response'
        })
            .pipe(map(user => {
                if (user.headers.get('Authorization')) {
                    localStorage.setItem(TOKEN_PADRAO, user.headers.get('Authorization'));
                }
                return user;
            }))
            .toPromise()
    }


    login(credentials) {
        return this.http.post(environment.URL_BASE_BACK_END_SPRING_CLOUD_ZUUL + 'api/authenticate', credentials, {observe: 'response'})
            .pipe(map(user => {
                return user.headers.get('Authorization');
            }))
            .toPromise();
    }

    captcha(): Promise<CaptchaModel> {
        return this.http.get<CaptchaModel>(environment.URL_BASE_BACK_END_SPRING_CLOUD_ZUUL + 'api/captcha')
            .toPromise();
    }

    loginGetToken() {
        return this.http.get(environment.URL_BASE_BACK_END_SPRING_CLOUD_ZUUL + 'api/auth', {observe: 'response'})
            .pipe(map(user => {
                return user.headers.get('Authorization');
            }))
            .toPromise();
    }


    public verificarToken(): Boolean {
        if (localStorage.getItem(TOKEN_PADRAO)) {
            this.mostrarMenuEmitter.emit(false);
            return true;
        }
        this.mostrarMenuEmitter.emit(true);
        return false;
    }

    mostrarMenu(value) {
        this.mostrarMenuEmitter.emit(value)
    }

    mostrarInputLogin(value) {
        this.mostrarLoginInputEmitter.emit(value)
    }

    isUsuarioAutenticado() {
        return this.mostrarMenuEmitter;
    }

    esconderMenu() {
        this.mostrarMenuEmitter.emit(false);
        return;
    }

    // interceptor
    logout() {
        this.mostrarMenuEmitter.emit(false);
        localStorage.clear();
        sessionStorage.clear();
        // this.router.navigateByUrl('/login');
        this.router.navigate(['/login'], {skipLocationChange: true});
    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/login/service/login.service.ts